import React from "react";
import getPricingDataById from "./utils/get-pricing-data-by-id";
import useSalesFormStore from "../../../../../../../../stores/sales-form";
import formatPercentage from "./utils/format-percentage";
import formatCurrency from "./utils/format-currency";
import styles from "./style.module.scss";

const DualPricing = () => {
  const applicationData = useSalesFormStore((state) => state.applicationData);
  return (
    <div className={styles.dualPricing}>
      <div className={styles.rateCard}>
        <div className={styles.ratesList}>
          <div className={styles.rateItem}>
            <span className={styles.rateLabel}>
              Preferred dual pricing rate 
            </span>
            <span className={styles.rateValue}>
              {formatPercentage(
                getPricingDataById(35, applicationData?.prices)?.percent,
              )}
            </span>
          </div>

          <div className={styles.rateItem}>
            <span className={styles.rateLabel}>
              Per Transaction
            </span>
            <span className={styles.rateValue}>
              {formatCurrency(
                getPricingDataById(35, applicationData?.prices)?.dollars,
              )}
            </span>
          </div>


          <div className={styles.rateItem}>
            <span className={styles.rateLabel}>Monthly Fee</span>
            <span className={styles.rateValue}>
              {formatCurrency(
                getPricingDataById(17, applicationData?.prices)?.dollars,
              )}
              /mo
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DualPricing;
